var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCustomerActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2917 5.04168C13.2917 3.26978 11.8553 1.83337 10.0834 1.83337L9.90736 1.8381C8.21731 1.9295 6.87505 3.32886 6.87505 5.04168C6.87505 6.81362 8.3115 8.25003 10.0834 8.25003L10.2594 8.24526C11.9495 8.15391 13.2917 6.75454 13.2917 5.04168ZM11.0001 15.5834C11.0001 16.5851 11.2679 17.5244 11.7358 18.3334H3.66675V15.0334C3.66675 12.3679 5.71498 10.1945 8.28086 10.0875L8.4792 10.0834H11.6876C12.5226 10.0834 13.308 10.3021 13.9925 10.687C12.2158 11.5987 11.0001 13.4491 11.0001 15.5834ZM13.806 19.2914L16.5001 17.6459L19.1941 19.2914L18.4616 16.2207L20.8591 14.167L17.7124 13.9148L16.5001 11L15.2877 13.9148L12.141 14.167L14.5385 16.2207L13.806 19.2914Z",
    fill: "#2D3139"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCustomerActive);
export default __webpack_public_path__ + "static/media/ico-customer-active.7e7397b6b59d4bbe8b3138f74b02e857.svg";
export { ForwardRef as ReactComponent };